import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { EmailMessage } from '../types/EmailMessage';
import { getEmails, deleteAllEmails, deleteEmailById } from '../api/emailApi';
import { PageTitle } from '../components/PageTitle';
import '../styles/InboxPage.css';
import { IconInbox } from '@tabler/icons-react';


export function InboxPage() {
  const { email } = useParams();
  const [emails, setEmails] = useState<EmailMessage[]>([]);
  const [selected, setSelected] = useState<EmailMessage | null>(null);

  const load = async () => {
    if (!email) return;
    const data = await getEmails(email);
    setEmails(data);
  };

  const handleDeleteAll = async () => {
    if (email) {
      await deleteAllEmails(email);
      setEmails([]);
      setSelected(null);
    }
  };

  const handleDelete = async (id: string) => {
    await deleteEmailById(id);
    setEmails((prev) => prev.filter(e => e.id !== id));
    if (selected?.id === id) setSelected(null);
  };

  useEffect(() => {
    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, [email]);

  return (
  <>
    <PageTitle title="Inbox Viewer" />
    <div className="inbox-page">
      {/* Левая колонка */}
      <div className="inbox-left">
        <input className="email-address" type="text" value={email || ''} readOnly />
        <div className="inbox-actions">
          <button onClick={load}>Refresh</button>
          <button onClick={handleDeleteAll}>Delete All</button>
        </div>

        <div className="email-list">
          {emails.map(e => (
            <div
              key={e.id}
              className={`email-item ${selected?.id === e.id ? 'selected' : ''}`}
              onClick={() => setSelected(e)}
            >
              <div><strong>From:</strong> {e.from}</div>
              <div><strong>Subject:</strong> {e.subject}</div>
              <div><strong>Date:</strong> {new Date(e.receivedAt).toLocaleString()}</div>
              <button className="delete-btn" onClick={(ev) => { ev.stopPropagation(); handleDelete(e.id); }}>🗑</button>
            </div>
          ))}
        </div>
      </div>

      {/* ВЕРТИКАЛЬНАЯ ЛИНИЯ */}
      <div className="divider" />

      {/* Правая колонка */}
      <div className="inbox-right">
        {selected ? (
          <iframe
            title="email-view"
            srcDoc={selected.body}
            className="email-frame"
          />
        ) : (
          <div className="empty-placeholder">
            <IconInbox size={48} stroke={1.5} style={{ marginBottom: 12 }} />
            Select an email to view its content
          </div>
        )}
      </div>
    </div>
  </>
);

}
